import Box from "./Box";
import React from "react";
import Text from "./Text";
import ThreeColumnFormRow from "./ThreeColumnFormRow";
import TwoColumnFormRow from "./TwoColumnFormRow";

function HeaderRow({ colNo }) {
  return (
    <Box py={[28, null, 17, null]} minHeight={65}>
      {colNo === 3 ? (
        <ThreeColumnFormRow
          py={[null, "10px", null, null]}
          col1={<Text fontSize={[14, 16, 22, 22]}>Item</Text>}
          col2={<Text fontSize={[14, 16, 22, 22]}>Value</Text>}
          col3={<Text fontSize={[14, 16, 22, 22]}>Add item</Text>}
        />
      ) : (
        <TwoColumnFormRow
          py={[null, "10px", null, null]}
          col1={<Text fontSize={[14, 16, 22, 22]}>Item</Text>}
          col2={<Text fontSize={[14, 16, 22, 22]}>Add item</Text>}
        />
      )}
    </Box>
  );
}
export default HeaderRow;
